module.exports = __webpack_public_path__ + "img/store.1aba068c.svg";